<template>
  <div
    class="custom-token country-card card-condition connection-type"
    :class="{ noteq: model.predicate === 'NOT_EQUALS' || model.predicate === 'NOT_CONTAINS' }"
  >
    <ui-icon size="12" class="card-condition__close" @click="emit('remove', model)" icon="fas fa-times" />

    <div class="predicate-with-checkbox-wrapper">
      <ui-label class="mr-12" :text="t('Query Header')" />

      <ui-input
        class="mr-12"
        style="width: 180px"
        v-model="model.parameter"
        :placeholder="t('Header')"
        :hide-details="1"
      />

      <ui-select
        v-model="model.predicate"
        style="width: 200px"
        class="mr-12"
        :items="model.predicateList"
        item-text="label"
        item-value="value"
        :autocomplete="false"
        :return-object="false"
        :hide-details="1"
      />

      <ui-checkbox
        v-model="hasEmpty"
        class="connection-type__checkbox pb-0"
        :label="t('Include empty value')"
      />
    </div>

    <div class="country-card__search">
      <ui-select
        v-model="selected"
        :placeholder="t('Add parameter values...')"
        :label="t('Searchable')"
        :items="model.values"
        :hide-details="2"
        item-title="text"
        item-value="value"
        multiple
        chips
        combobox
        multi-line
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';
import type { FlowTokenModel } from './useFlowTokenModelsCondition';
import { useFlowTokenForm } from './useFlowTokenForm';

const props = defineProps<{
  model: FlowTokenModel;
  emptyValue: { text: string; value: string };
}>();

const emit = defineEmits<{
  remove: [model: FlowTokenModel];
}>();

const { t } = useI18n();

const { selected, hasEmpty } = useFlowTokenForm(props.model, props.emptyValue);
</script>

<style lang="scss"></style>
